import axios from '@/libraries/axios/main';
import ApiResponseOld from '@/interfaces/ApiResponseOld';

export async function fetchPendingSessions(): Promise<ApiResponseOld> {
  const response = await axios.get(`/session/pending`);

  return response.data;
}

export async function deletePendingSession(
  name: string,
): Promise<{ status: string, message: string }> {
  const response = await axios.delete(`/session/pending/delete/${name}`);

  return response.data as { status: string; message: string };
}
